import { GoogleReviewsService } from '@weave/schema-gen-ts/dist/schemas/reviews/google-reviews/v1/reviews_google.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaGoogleReviewsV1Service = bindHTTP(GoogleReviewsService);
export const serviceName = 'google-reviews-v1' as const;
